import axios from '@/http/axios/axios'

export default {
  namespaced: true,
  actions: {
    GET_LIST() {
      return new Promise((resolve, reject) => {
        axios
          .get('dictionary/social-network/?paginate=None')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}